// extracted by mini-css-extract-plugin
export default {"div__container":"App_div__container__ABKJU","div__container_bc":"App_div__container_bc__qiJQB"};